export const SESSIONSTORAGE_REFERRAL = 'referral';
export const SESSIONSTORAGE_ENGAGED_FREETRIALER_CONFIRMATION =
  'ENGAGED_FREETRIALER_CONFIRMATION';
export const SESSIONSTORAGE_HIDE_MOBILE_APP_SMART_BANNER =
  'hideMobileAppSmartBanner';
// save route when entering inside cart page, in order to comeback when closing cart page on mobile browser
export const SESSIONSTORAGE_ROUTE_URL_BEFORE_CART_PAGE =
  'routeUrlBeforeCartPage';
export const SESSIONSTORAGE_USER_EMAIL = 'friendemail';
export const SESSIONSTORAGE_COUPON = 'coupon';
